import { render, staticRenderFns } from "./ContentdisplayConfirmation.vue?vue&type=template&id=b06702fc&scoped=true"
import script from "./ContentdisplayConfirmation.vue?vue&type=script&lang=js"
export * from "./ContentdisplayConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ContentdisplayConfirmation.vue?vue&type=style&index=0&id=b06702fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06702fc",
  null
  
)

export default component.exports